import * as React from "react";
import {createBrowserRouter,} from "react-router-dom";
import ErrorPage from "../Pages/ErrorPage";
import App from "../../App";
import {PATH} from "./Path";
import Home from "../Pages/Home";
import FormPage from "../Pages/Forms/FormPage";
import WorkersPage from "../Pages/WorkersFolder/WorkersPage";
import ScanPage from "../Pages/Forms/ScanPage";
import LaborantForm from "../Pages/Forms/LaborantForm";
import DoctorForm from "../Pages/Forms/DoctorForm";
import Referrals from "../Pages/ReferralFolder/PatientRefferals/ReferralsList";
import PatientCard from "../Pages/PatientFolder/PatientCard";
import AddUser from "../Pages/WorkersFolder/AddUser";
import EditUser from "../Pages/ReferralFolder/PatientRefferals/EditReferral";
import EditPatient from "../Pages/PatientFolder/EditPatient";
import PatientList from "../Pages/PatientFolder/PatientList";
import FindPatientForm from "../Pages/Forms/FindPatientForm";
import DocPermission from "./DocPermission";
import RefferalCard from "../Pages/ReferralFolder/PatientRefferals/RefferalCard";
import LogsPage from '../Pages/LogsPage/index'
import AdminPermission from "./AdminPermisson";
import LaborantPermission from "./LaborantPermisson";
import RegistarPermission from "./RegistarPermisson";
import Contracts from "../Pages/Contracts";
import NewContracts from "../Pages/NewContracts";
import EditContract from "../Pages/EditContracts";
import AddClinic from "../Pages/Clinic/AddClinic";
import ClinicList from "../Pages/Clinic/ClinicList";
import Statistics from "../Pages/Statistic";
import EditClinic from "../Pages/Clinic/EditClinic";
import ReferralCardEdit from "../Pages/ReferralFolder/PatientRefferals/RefferalCardEdit";


export const router = createBrowserRouter([
    {
        path: "/",
        element: <App/>,
        errorElement: <ErrorPage/>,
        children: [
            {
                path: PATH.FormPage,
                element:
                    <DocPermission>
                        <FormPage/>
                    </DocPermission>,
            }, {
                path: PATH.Home,
                element: <Home/>,
            }, {
                path: PATH.WorkersList,
                element:
                    <AdminPermission>
                        <WorkersPage/>
                    </AdminPermission>,
            }, {
                path: PATH.PatientList,
                element: <PatientList/>,
            }, {
                path: PATH.ScanPage,
                element:
                    <LaborantPermission>
                        <ScanPage/>
                    </LaborantPermission>,
            }, {
                path: PATH.RegistrationForm,
                element:
                    <RegistarPermission>
                        <FindPatientForm/>
                    </RegistarPermission>,
            }, {
                path: PATH.LaborantForm,
                element: <LaborantForm/>,
            }, {
                path: PATH.DoctorForm,
                element: <DoctorForm/>,
            }, {
                path: PATH.Referrals,
                element: <Referrals/>,
            }, {
                path: PATH.Anamnez,
                element: <PatientCard/>,
            }, {
                path: PATH.NewUser,
                element:
                    <AdminPermission>
                        <AddUser/>
                    </AdminPermission>,
            }, {
                path: PATH.NewClinic,
                element: <AddClinic/>
            }, {
                path: PATH.EditUser,
                element: <EditUser/>,
            }, {
                path: PATH.EditPatient,
                element: <EditPatient/>,
            }, {
                path: PATH.ReferralCard,
                element: <RefferalCard/>,
            },, {
                path: PATH.ReferralCardEdit,
                element: <ReferralCardEdit/>,
            }, {
                path: PATH.ClinicList,
                element: <AdminPermission><ClinicList/></AdminPermission>,
            }, {
                path: PATH.EditClinic,
                element: <EditClinic/>,
            }, {
                path: PATH.LogsPage,
                element:
                    <AdminPermission>
                        <LogsPage/>
                    </AdminPermission>,
            }, {
                path: PATH.Contracts,
                element:
                    <AdminPermission>
                        <Contracts/>
                    </AdminPermission>
            },
            {
                path: PATH.Statistics,
                element:
                <AdminPermission>
                    <Statistics/>
                </AdminPermission>
            }
            , {
                path: PATH.NewContracts,
                element:
                    <AdminPermission>
                        <NewContracts/>
                    </AdminPermission>
            }, {
                path: PATH.EditContract,
                element:
                    <AdminPermission>
                        <EditContract/>
                    </AdminPermission>
            }
        ]
    },
]);

